module.exports = __webpack_public_path__ + "media/אופנוע.43980e31.mp3";